module.exports = __webpack_public_path__ + "static/media/logo digitadis-01.07a44063.png";